class ScrollingText {
  constructor() {
    this.section = document.getElementById('section-dinamyc-text');
    this.text1 = document.getElementById('section-dinamyc-text-first_heading');
    this.text2 = document.getElementById('section-dinamyc-text-last_heading');

    this.initEventListeners();
  }

  initEventListeners() {
    document.addEventListener('scroll', () => this.handleScroll());
  }

  handleScroll() {
    const sectionPosition = this.section.getBoundingClientRect();
    // Calculate the scroll within the section
    if (sectionPosition.top < window.innerHeight && sectionPosition.bottom > 0) {
      const displacement = Math.max(0, window.innerHeight - sectionPosition.top);
      const movementFactor = (displacement / window.innerHeight) * 700; // This value can be adjusted

      // Apply movement in opposite directions
      this.text1.style.transform = `translate3d(${
        movementFactor - 1000
      }px, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`;
      this.text2.style.transform = `translate3d(${
        300 + movementFactor * -1
      }px, 0, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`;
    }
  }
}
